import React from "react";
import NoDataImg from "../../../images/dhangold/NoData.png";

const NoDataFound = ({ width = 500 }) => {
  return (
    <>
      <img src={NoDataImg} width={width} alt='No Data Found' />
    </>
  );
};

export default NoDataFound;
